import React from 'react';
import { Star, Quote } from 'lucide-react';
const testimonials = [{
  name: 'María Fernández',
  role: 'Profesora de Derecho, Buenos Aires',
  age: '42',
  text: 'Antes pasaba horas buscando material. Ahora entro al aula tranquila sabiendo que todo está listo. Mis alumnos participan más y yo recuperé mi tiempo personal.'
}, {
  name: 'Roberto Sánchez',
  role: 'Docente Secundario, Córdoba',
  age: '38',
  text: 'DERECHO 360 cambió mi forma de enseñar. Las clases están tan bien armadas que los chicos entienden conceptos que antes les costaban. Es como tener un asistente experto.'
}, {
  name: 'Laura Gómez',
  role: 'Profesora, Rosario',
  age: '45',
  text: 'Lo mejor es que no tengo que improvisar más. Cada clase tiene actividades que realmente funcionan con adolescentes. Vale cada peso invertido.'
}, {
  name: 'Carlos Méndez',
  role: 'Docente de Derecho, Mendoza',
  age: '51',
  text: 'Llevo 20 años enseñando y este es el mejor material que encontré. Completo, claro y pensado para la realidad del aula argentina. Mis clases mejoraron notablemente.'
}, {
  name: 'Patricia Ruiz',
  role: 'Profesora, Tucumán',
  age: '36',
  text: 'Recuperé mis noches y fines de semana. Ya no me llevo trabajo a casa porque todo está resuelto. Mis alumnos aprenden mejor y yo disfruto más de enseñar.'
}];
export function TestimonialsSection() {
  return <section className="py-20 bg-amber-50" data-id="element-245">
      <div className="container mx-auto px-4" data-id="element-246">
        <div className="text-center mb-16" data-id="element-247">
          <h2 className="text-3xl md:text-4xl font-bold text-slate-900 mb-4" data-id="element-248">
            Lo que dicen otros docentes
          </h2>
          <p className="text-slate-600" data-id="element-249">
            Colegas de todo el país que ya usan DERECHO 360
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6 max-w-7xl mx-auto" data-id="element-250">
          {testimonials.map((t, i) => <div key={i} className="bg-white p-6 rounded-xl border border-amber-200 shadow-sm hover:shadow-md transition-shadow" data-id="element-251">
              <div className="flex gap-1 mb-4" data-id="element-252">
                {[1, 2, 3, 4, 5].map(star => <Star key={star} className="h-4 w-4 fill-amber-500 text-amber-500" data-id="element-253" />)}
              </div>
              <div className="relative" data-id="element-254">
                <Quote className="absolute -top-2 -left-2 h-8 w-8 text-amber-100 -z-10" data-id="element-255" />
                <p className="text-slate-700 mb-6 relative z-10 italic" data-id="element-256">
                  "{t.text}"
                </p>
              </div>
              <div className="border-t border-amber-200 pt-4" data-id="element-257">
                <p className="font-bold text-slate-900" data-id="element-258">
                  {t.name}, {t.age}
                </p>
                <p className="text-sm text-slate-500" data-id="element-259">{t.role}</p>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}